export default __webpack_public_path__ + "deedf5fe9ea819c6ae9b3e2618d132c8.png";